
const SidebarHelper = {
    // ---- methods ----
    checkPermissionList: (items, permissionList) => {
        if (!permissionList?.length) return items;

        const formattedPermissionList = [
            ...new Set(
                permissionList?.map((permission) => {
                    const path = permission?.path || '';
                    const parts = path.split('/').filter(Boolean);

                    if (parts.length === 0) return null;

                    if (parts.length === 1) {
                        return `/${parts[0]}`;
                    }

                    return '/' + parts.slice(0, -1).join('/');
                })
            )
        ].filter(Boolean);

        const itemsList = items
            ?.map((item) => {
                if (item.type === 'item') {
                    if (item?.subMenuItems) {
                        const filteredSubMenuItems = item.subMenuItems
                            .filter((subMenuItem) => formattedPermissionList?.includes(subMenuItem?.path))
                            ?.map((subMenuItem) => subMenuItem);

                        if (filteredSubMenuItems.length > 0) {
                            return {
                                ...item,
                                subMenuItems: filteredSubMenuItems,
                            };
                        }
                    }
                    if (formattedPermissionList?.includes(item?.path)) {
                        return item;
                    }
                } else return item;
                return null;
            })
            .filter((item) => item !== null);

        return itemsList;
    },

};

export default SidebarHelper;
